var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
import MenuSchema from "src/shared/navigation/MenuSchema";
import MainNavigationItem from "./MainNavigationItem.vue";
import { onMounted, ref, nextTick, watch, onUnmounted } from "vue";
import { useSecondaryMenuParent } from "../composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MainNavigation',
    props: {
        hasClientSelector: { type: Boolean },
        isUserSupportUser: { type: Boolean },
        isSelfServiceUser: { type: Boolean },
        height: {}
    },
    emits: ["expansion-changed"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const menuSchema = new MenuSchema();
        const menuItems = menuSchema.parseItems();
        const currentPage = ref(window.location.pathname + window.location.hash);
        const defaultEntryItem = props.isUserSupportUser ? "user-support" : "programs";
        const { secondaryMenuParent, updateFromCurrentPath } = useSecondaryMenuParent();
        const activeItem = ref(null);
        const mainNavigationEl = ref(null);
        let originalPushState;
        let originalReplaceState;
        const checkScrollNeeded = () => {
            nextTick(() => {
                const navElement = mainNavigationEl.value;
                const clientHeight = (navElement === null || navElement === void 0 ? void 0 : navElement.clientHeight) || 0;
                const height = props.height < clientHeight ? props.height : clientHeight;
                if (navElement && navElement instanceof HTMLElement) {
                    if (navElement.scrollHeight > height) {
                        navElement.classList.add("needs-scroll");
                    }
                    else {
                        navElement.classList.remove("needs-scroll");
                    }
                }
            });
        };
        watch(() => props.height, () => {
            checkScrollNeeded();
        });
        let scrollCheckTimeout = null;
        const debouncedCheckScrollNeeded = () => {
            if (scrollCheckTimeout) {
                clearTimeout(scrollCheckTimeout);
            }
            scrollCheckTimeout = window.setTimeout(checkScrollNeeded, 50);
        };
        const onToggleNav = (itemName) => {
            if (itemName === activeItem.value) {
                activeItem.value = null;
            }
            else {
                activeItem.value = itemName;
            }
            checkScrollNeeded();
        };
        watch(activeItem, () => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            emit("expansion-changed");
            checkScrollNeeded();
        }));
        watch(secondaryMenuParent, (newValue) => {
            activeItem.value = newValue;
            debouncedCheckScrollNeeded();
        });
        const updateCurrentPage = () => {
            const newPage = window.location.pathname + window.location.hash;
            if (newPage !== currentPage.value) {
                currentPage.value = newPage;
                updateFromCurrentPath();
            }
        };
        onMounted(() => {
            activeItem.value = secondaryMenuParent.value;
            mainNavigationEl.value = document.getElementById("js-main-navigation");
            originalPushState = history.pushState;
            originalReplaceState = history.replaceState;
            history.pushState = function (state, title, url) {
                originalPushState.call(history, state, title, url);
                window.dispatchEvent(new CustomEvent("locationchange"));
            };
            history.replaceState = function (state, title, url) {
                originalReplaceState.call(history, state, title, url);
                window.dispatchEvent(new CustomEvent("locationchange"));
            };
            window.addEventListener("locationchange", updateCurrentPage);
            window.addEventListener("popstate", updateCurrentPage);
            window.addEventListener("hashchange", updateCurrentPage);
            window.addEventListener("resize", debouncedCheckScrollNeeded);
            checkScrollNeeded();
            setTimeout(checkScrollNeeded, 100);
            setTimeout(checkScrollNeeded, 500);
            setTimeout(checkScrollNeeded, 1000);
        });
        onUnmounted(() => {
            window.removeEventListener("locationchange", updateCurrentPage);
            window.removeEventListener("popstate", updateCurrentPage);
            window.removeEventListener("hashchange", updateCurrentPage);
            window.removeEventListener("resize", debouncedCheckScrollNeeded);
            if (originalPushState) {
                history.pushState = originalPushState;
            }
            if (originalReplaceState) {
                history.replaceState = originalReplaceState;
            }
            if (scrollCheckTimeout !== null) {
                clearTimeout(scrollCheckTimeout);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_TransitionGroup, {
                tag: "ul",
                name: "list",
                id: "js-main-navigation",
                class: _normalizeClass(["main-navigation", { 'main-navigation--with-clients': _ctx.hasClientSelector }])
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item) => {
                        return (_openBlock(), _createBlock(MainNavigationItem, {
                            key: item.name,
                            item: item,
                            hasClientSelector: _ctx.hasClientSelector,
                            isUserSupportUser: _ctx.isUserSupportUser,
                            isSelfServiceUser: _ctx.isSelfServiceUser,
                            isExpanded: activeItem.value === item.name,
                            currentPage: currentPage.value,
                            onToggledNav: onToggleNav
                        }, null, 8 /* PROPS */, ["item", "hasClientSelector", "isUserSupportUser", "isSelfServiceUser", "isExpanded", "currentPage"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["class"]));
        };
    }
});
